module.exports = __webpack_public_path__ + "img/male.811ecd85.svg";